export default __webpack_public_path__ + "static/media/Estafeta_Logo.637ab385.svg";